<div *ngIf="transactions?.length > 0" class="container">
  <client-detail-expansion [transaction]="transactions[0]"></client-detail-expansion>
  <div class="title">{{ 'transactionDetail.title' | translate }}</div>
  <div [ngClass]="{'object-separator': !isFirst}" *ngFor="let transaction of transactions; first as isFirst">
    <transaction-detail [transaction]="transaction"></transaction-detail>
  </div>
</div>